var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title-component d-flex flex-column flex-sm-row justify-content-between align-items-center w-100 mb-3"},[_c('div',{staticClass:"d-flex flex-row pb-3 pb-sm-0"},[_c('h2',{staticClass:"h4"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("status")],2),_c('v-spacer'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }